module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_2.57ebe781.pdf";